// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"540bd904","94":"98d555d7","239":"3fec4b50","259":"8a521c97","394":"cc389eb9","451":"58876849","512":"97629025","525":"a19eb20d","553":"8e7ad782","792":"8110e866","907":"96fbf7d4","965":"b94015c9"}[chunkId] + ".chunk.js";
};